import React, { useState, useEffect, useRef } from 'react';

interface HoverPreviewProps {
  thumbnailUrl: string;
}

export const HoverPreview: React.FC<HoverPreviewProps> = ({ thumbnailUrl }) => {
  const [videoError, setVideoError] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  
  // Try to derive MP4 url from the thumbnail JPG url
  const videoUrl = thumbnailUrl.replace('.jpg', '.mp4').replace('.jpeg', '.mp4').replace('.png', '.mp4');

  useEffect(() => {
    if (videoRef.current) {
      // Play automatically when mounted
      videoRef.current.play().catch(e => {
        // Autoplay might be blocked or file might not exist
        setVideoError(true);
      });
    }
  }, []);

  if (videoError) {
    // Fallback: If video fails, just return null so the GameCard zoomed image underneath shows
    return null;
  }

  return (
    <video
      ref={videoRef}
      src={videoUrl}
      muted
      loop
      playsInline
      onError={() => setVideoError(true)}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 5
      }}
    />
  );
};
